import React, { useEffect, useState } from 'react';
import { fetchEmployeeData } from '../Services/Employees';
import './EmployeeDashboard.css';
const EmployeeDashboard = () => {
  const [employeeData, setEmployeeData] = useState({});

  useEffect(() => {
    fetchEmployeeData()
      .then((response) => {
        //localStorage.setItem("UserName",response.data.employeeData.employeeName);
        localStorage.setItem("UserName",response.data.employeeName);
        setEmployeeData(response.data);
       
      })
      .catch((error) => {
        console.error('Error fetching employee data:', error);
      });
  }, []);

  return (
    <div className="employee-dashboard">
      <div className="card border-0" style={{ background: "white" }}>
        <div className="card-header " style={{backgroundColor:"transparent"}} >
          <h5 className="card-title text-center mb-0 py-2">Personal Details</h5>
        </div>
        <div className="card-body">
          <table className="table table-bordered rounded-0 table-light" style={{tableLayout:"fixed"}}>
            <tbody>
              <tr>
                <td><strong>Employee Name:</strong></td>
                <td>{employeeData.employeeName}</td>
                <td><strong>Hrms ID:</strong></td>
                <td>{employeeData.hrmsId}</td>
              </tr>
              <tr>
                <td><strong>Designation:</strong></td>
                <td>{employeeData.designation}</td>
                <td><strong>Station:</strong></td>
                <td>{employeeData.station}</td>
              </tr>
              <tr>
                <td><strong>Father Name:</strong></td>
                <td>{employeeData.fatherName}</td>
                <td><strong>Mobile Number:</strong></td>
                <td>{employeeData.mobileNumber}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default EmployeeDashboard;
